<template>
    <div
        v-show="state && state.results && state.results.nbHits !== 0"
        id="algolia_results"
    >
        <a :href="banner.link?.url" v-if="banner">
            <img
                class="algolia-listing-banner"
                :src="banner.image.urls[0]?.url"
                :alt="banner.image.alt"
            />
        </a>

        <div class="algolia-listing-filters__product-listing-wrapper">

            <ais-stats>
                <template
                    v-slot="{
                        hitsPerPage,
                        nbPages,
                        nbHits,
                        page,
                        processingTimeMS,
                        query
                    }"
                >
                    <div class="algolia-listing-hits">
                        {{ nbHits }}
                        {{ $t("algoliaSearch.resultsHitsProducts") }}
                    </div>
                </template>
            </ais-stats>
            <ais-clear-refinements>
                <template v-slot="{ canRefine, refine, createURL }">
                    <a
                        class="algolia-listing-filters__delete-all-button"
                        :href="createURL()"
                        @click.prevent="refine"
                        v-if="canRefine"
                    >
                        {{ $t("algoliaSearch.resultsHitsDelete") }}
                        <svg
                            width="9"
                            height="10"
                            viewBox="0 0 9 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M6.20591 5L8.76452 2.26371C9.07849 1.92793 9.07849 1.38352 8.76452 1.04746L8.19588 0.439336C7.8819 0.103555 7.37284 0.103555 7.05861 0.439336L4.5 3.17562L1.94139 0.439336C1.62741 0.103555 1.11835 0.103555 0.804119 0.439336L0.235483 1.04746C-0.0784943 1.38324 -0.0784943 1.92766 0.235483 2.26371L2.79409 5L0.235483 7.73629C-0.0784943 8.07207 -0.0784943 8.61648 0.235483 8.95254L0.804119 9.56066C1.1181 9.89645 1.62741 9.89645 1.94139 9.56066L4.5 6.82438L7.05861 9.56066C7.37259 9.89645 7.8819 9.89645 8.19588 9.56066L8.76452 8.95254C9.07849 8.61676 9.07849 8.07234 8.76452 7.73629L6.20591 5Z"
                                fill="#E53F00"
                            />
                        </svg>
                    </a>
                    <div
                        v-else
                        class="algolia-listing-filters--product-listing"
                    >
                        <button
                            class="algolia-listing-filters__filter-arrow-button"
                        >
                            <i class="fa fa-chevron-left"></i>
                        </button>
                        <div
                            class="algolia-listing-filters__filter-note-wrapper"
                        >
                            <div
                                class="algolia-listing-filters__filter-note-heading"
                            >
                                {{ $t("algoliaSearch.resultsHitsFilter") }}
                            </div>
                            <p
                                class="algolia-listing-filters__filter-note-text"
                            >
                                {{ $t("algoliaSearch.resultsHitsFilterNote") }}
                            </p>
                        </div>
                    </div>
                </template>
            </ais-clear-refinements>


            <div
                class="algolia-listing-filters__product-listing-active-refinements"
            >
                <ais-current-refinements>
                    <template v-slot:item="{ item, refine, createURL }">
                        <div
                            v-for="refinement in item.refinements"
                            :key="
                                [
                                    refinement.attribute,
                                    refinement.type,
                                    refinement.value,
                                    refinement.operator
                                ].join(':')
                            "
                        >
                            <a
                                class="algolia-listing-filters__active-filter-block"
                                :href="createURL(refinement)"
                                @click.prevent="refine(refinement)"
                            >
                                <span
                                    v-if="
                                        refinement.attribute ===
                                            'combinations.price_reduction'
                                    "
                                >
                                    {{ $t("myAccount.appModalListItemLink") }}:
                                    {{
                                        refinement.label === "1"
                                            ? $t(
                                                "algoliaSearch.filters.priceReduction.on"
                                            )
                                            : $t(
                                                "algoliaSearch.filters.priceReduction.off"
                                            )
                                    }}
                                </span>
                                <span v-else>{{ refinement.label }}</span>

                                <svg
                                    width="9"
                                    height="10"
                                    viewBox="0 0 9 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6.20591 5L8.76452 2.26371C9.07849 1.92793 9.07849 1.38352 8.76452 1.04746L8.19588 0.439336C7.8819 0.103555 7.37284 0.103555 7.05861 0.439336L4.5 3.17562L1.94139 0.439336C1.62741 0.103555 1.11835 0.103555 0.804119 0.439336L0.235483 1.04746C-0.0784943 1.38324 -0.0784943 1.92766 0.235483 2.26371L2.79409 5L0.235483 7.73629C-0.0784943 8.07207 -0.0784943 8.61648 0.235483 8.95254L0.804119 9.56066C1.1181 9.89645 1.62741 9.89645 1.94139 9.56066L4.5 6.82438L7.05861 9.56066C7.37259 9.89645 7.8819 9.89645 8.19588 9.56066L8.76452 8.95254C9.07849 8.61676 9.07849 8.07234 8.76452 7.73629L6.20591 5Z"
                                        fill="#757575"
                                    />
                                </svg>
                            </a>
                        </div>
                    </template>
                </ais-current-refinements>
            </div>
        </div>

        <ais-hits>
            <template v-slot="{ items, sendEvent, banner }">

                {{ setBanner(banner) }}

                <HitItems
                    :action-banners="actionBanners"
                    :lang-iso="langIso"
                    :items="items"
                    :page-type="pageType"
                    @algolia-event="sendAlgoliaEvent($event.title, $event.item)"
                />
            </template>
        </ais-hits>


        <ais-pagination>
            <template
                v-slot="{
                    currentRefinement,
                    nbPages,
                    pages,
                    isFirstPage,
                    isLastPage,
                    refine,
                    createURL
                }"
            >
                <Pagination
                    :current-refinement="currentRefinement"
                    :nb-pages="nbPages"
                    :pages="pages"
                    :is-first-pages="isFirstPage"
                    :is-last-page="isLastPage"
                    :refine="refine"
                    :create-u-r-l="createURL"
                />
            </template>
        </ais-pagination>
    </div>
</template>

<script>
import { connectHits } from "instantsearch.js/es/connectors";
import { createWidgetMixin } from "vue-instantsearch/vue3/es";
import {
    AisCurrentRefinements,
    AisQueryRuleCustomData,
    AisClearRefinements,
    AisHits,
    AisStats,
    AisPagination
} from "vue-instantsearch/vue3/es";
import Pagination from "./Partials/Pagination";
import HitItems from "./Partials/HitItems";

export default {
    name: "AlgoliaSearchResults",
    components: {
        HitItems,
        Pagination,
        AisCurrentRefinements,
        AisClearRefinements,
        AisQueryRuleCustomData,
        AisHits,
        AisStats,
        AisPagination,
    },
    data() {
        return {
            banner: null,
        };
    },
    props: {
        pageType: {
            type: String,
            required: false,
            default: "Category"
        },
        langIso: {
            type: String,
            required: false,
            default: "nl-NL"
        },
        userToken: {
            type: String,
            required: false,
            default: null,
        },
        actionBanners: {
            type: Array,
            required: false,
            default: () => [],
        }
    },
    methods: {
        setBanner(banner) {
            this.banner = banner
        },
        sendAlgoliaEvent(name, item) {
            if (!item) {
                return;
            }
            let clickEventParameters = {};
            if (item.__queryID) {
                clickEventParameters = {
                    'positions': [item.__position],
                    'queryID': item.__queryID,
                };
            }
            window.sendAlgoliaEvent({
                'eventType': 'click',
                'eventName': name,
                'index': algolia_index_name,
                'userToken': this.userToken,
                'timestamp': Date.now(),
                'objectIDs': [item.objectID],
                ...clickEventParameters,
            });
        },
    },
    mixins: [createWidgetMixin({ connector: connectHits })]
};
</script>
